import * as z from "zod";
import { merchantSignupFormWithAnalyticsOutputSchema } from "./signup-form-output-schema";

export const getSignupFormsByTeamId = {
  name: "getSignupFormsByTeamId" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(merchantSignupFormWithAnalyticsOutputSchema),
};
